/**
 * GetControledePatrimonioInspecaoByIdUseCase
 */

import { IGetControledePatrimonioInspecaoByIdUseCase } from "../../../presentation/useCases/read/get_controlede_patrimonio_inspecao_by_id_use_case";
import {
  GetControledePatrimonioInspecaoByIdRequestModel,
  GetControledePatrimonioInspecaoByIdResponseModel,
} from "../../models/ControledePatrimonioInspecao";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class GetControledePatrimonioInspecaoByIdUseCase implements IGetControledePatrimonioInspecaoByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {}

  async getControledePatrimonioInspecaoById(
    model: GetControledePatrimonioInspecaoByIdRequestModel,
  ): Promise<GetControledePatrimonioInspecaoByIdResponseModel> {
    return await this.repository.getControledePatrimonioInspecaoById(model);
  }
}
